import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export const IntegrationType = {
	Allegro: 'Allegro',
	AllegroSandbox: 'AllegroSandbox'
} as const;

export type IntegrationType = typeof IntegrationType[keyof typeof IntegrationType];

export type IntegrationsListItem = {
	accountGuid: string,
	name: string,
	providerAccountName: string,
	providerType: IntegrationType,
	authenticationType: string,
	isActive: boolean,
	isConnected: boolean,
	lastSyncDate: Date,
	createdDate: Date,
	modifiedDate: Date,
};

type IntegrationsListResponse = {
	data: {
		items: IntegrationsListItem[],
		metadata: {
			page: number,
			total: number
		}
	}
};

export class IntegrationsListQuery extends Query<IntegrationsListItem[]> { }

export class IntegrationsListQueryHandlerBase implements QueryHandler<IntegrationsListQuery, IntegrationsListItem[]> {
	private static Url = TaggedUrl.join('MarketplaceAccounts', [Tags.SelloApi]);

	public constructor(
		private readonly http: HttpService
	) { }

	public async handleAsync(_: IntegrationsListQuery): Promise<IntegrationsListItem[]> {
		const response = await this.http.get<IntegrationsListResponse>(IntegrationsListQueryHandlerBase.Url);
		return response.data.data.items;
	}
}
